import(/* webpackMode: "eager" */ "/codebuild/output/src135302362/src/src/app/(public)/adopt/[shelterKey]/page.tsx");
